// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CompassIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 3a13 13 0 1 0 13 13A13.013 13.013 0 0 0 16 3Zm0 24a11 11 0 1 1 11-11 11.012 11.012 0 0 1-11 11Zm5.552-17.895-8 4c-.193.097-.35.254-.447.447l-4 8a1 1 0 0 0 1.342 1.343l8-4c.194-.097.35-.254.448-.447l4-8a1 1 0 0 0-1.343-1.343ZM17.25 17.25l-5.014 2.514 2.514-5.014 5.019-2.509-2.519 5.009Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
